import React, { Component, Fragment } from 'react'
import Breadcrumb from '../common/breadcrumb';
import VerProductCollectionsDatatable from '../common/ver-product-collections-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

export class Ver_product_collections extends Component {

    constructor(props) {
        super(props);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.state = {
            results: [],
            temp: [],
        };
    }

    onChangeFilter(e) {
        this.setState({
            filter: e.target.value
        }, function () {
        });

        const val = e.target.value.toLowerCase();
        if (this.state.temp.length != 0) {
          var columns = Object.keys(this.state.temp[0]);
          columns.splice(columns.length);

          if (!columns.length)
            return;
          const rows = this.state.temp.filter(function (d) {
            for (let i = 0; i <= columns.length; i++) {
              let column = columns[i];
              if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
                return true;
              }
            }
          });
          this.setState({
            results: rows
        }, function () {
            this.renderResults(this.state.results.length);
        });
        }

        e.preventDefault();
      }

    componentWillMount() {
        this.getDataProductCollections();
    }

    showStatus(results){
		for (let i = 0; i < results.length; i++){
			if( (results[i]['collection_status'] === 'ACTIVO') ){
				results[i]['collection_status'] = <i className="fa fa-circle font-success f-12"/>;
			}else{
				results[i]['collection_status'] = <i className="fa fa-circle font-danger f-12"/>;
            }
		}
		return results;
	}

    getDataProductCollections(){
        var user = AuthService.getCurrentUser();
        ApiService.getProductCollections(user.token).then(
            (res) => {
                if (!res || !res.data || !Array.isArray(res.data)) {
                    this.setState({ results: [], temp: [] });
                    return;
                }
                const items = this.showStatus(res.data).map(function(row) {
                    const productCount = row.CollectionProducts ? row.CollectionProducts.length : 0;
                    return {
                        ['#']: row.id,
                        id: row.id,
                        Nombre : row.collection_name,
                        Código : row.collection_code || '-',
                        Productos: productCount,
                        Estado : row.collection_status,
                        data : row,
                    }
                 })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderResults(length){
		return this.state.results.length === 0
			? 'No hay datos.'
			: <VerProductCollectionsDatatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=10?length:10}
            pagination={true}
            class="-striped -highlight"
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Colecciones de Productos" parent="Promociones" />
                {/* <!-- Container-fluid starts--> */}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Colecciones de Productos</h5>
                                </div>
                                <div className="card-body">
                                    <div className="clearfix"></div>
                                    <div id="basicScenario" className="product-physical">
                                    <div className="col-md-6 table-filter">
                                    <Link to={`${process.env.PUBLIC_URL}/add-product-collection`}  type="button" className="btn btn-secondary" data-toggle="modal" data-original-title="test" data-target="#exampleModal" style={{marginBottom: '1rem', float: 'right'}}>Añadir Colección</Link>
                                    <input
                                        placeholder="Escriba para filtrar todas las columnas"
                                        name="filter"
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        onInput={this.onChangeFilter}
                                    />
                                    </div>
                                        {this.renderResults()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Container-fluid Ends--> */}
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_product_collections
